export default "__VITE_ASSET__BTmmZYDB__"